import { defineMessages } from 'react-intl';

const messages = defineMessages({
  itemName: {
    description: 'Label for column representing the item name',
    defaultMessage: 'Item Name',
    id: '8FW8wk',
  },
  itemSku: {
    description: 'Sku prefix before actual item sku',
    defaultMessage: 'SKU: {sku}',
    id: 'YVi6+D',
  },
  itemBundleProductSku: {
    description: 'Bundle Sku prefix before actual item sku',
    defaultMessage: 'Bundle SKU: {bundleProductSku}',
    id: 'OnARFR',
  },
  itemOrderNumber: {
    description: 'The order number of an items original order',
    defaultMessage: '*from Order # {orderNumber}',
    id: '0ZV10h',
  },
});

export default messages;
